import { Box, CircularProgress, Modal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette }) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: palette.common.white,
  },
}));

export default function LoadingOverlay() {
  const classes = useStyles();

  return (
    <Modal className={classes.modal} open>
      <Box tabIndex={-1} textAlign="center">
        <CircularProgress color="inherit" />
      </Box>
    </Modal>
  );
}
